import { CustomTheme } from '@nemuru-eng/js-api-client';

import { Theme } from '@/config/types';

export const nemuruTheme: Partial<Theme> = {
  zendeskCustomerSupport: true,
  themeName: CustomTheme.NEMURU,
  logoUrl: 'https://cdn.nemuru.com/assets/logos/nemuru-logo.svg',
  palette: {
    primary: {
      main: '#4dd970',
      contrastText: '#08404d',
    },
    secondary: {
      light: '#327587',
      main: '#08404d',
      contrastText: '#fff',
    },
    error: {
      light: '#fbefee',
      main: '#ef5957',
      contrastText: '#ffffff',
    },
    warning: {
      light: '#fefbf3',
      main: '#ffca28',
      contrastText: '#ffffff',
    },
    info: {
      light: '#eef5fd',
      main: '#36a3f7',
      dark: '#08404d',
      contrastText: '#ffffff',
    },
    success: {
      light: '#f1faf1',
      main: '#4dd970',
      dark: '#43b46f',
      contrastText: '#ffffff',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f2',
      200: '#eae9e6',
      300: '#dad9d6',
      400: '#b6b5b2',
      500: '#8f9696',
      600: '#4f6565',
      700: '#345050',
      800: '#2a3f3f',
      900: '#0e1a1a',
    },
    text: {
      title: '#08404d',
      primary: '#4b5354',
      secondary: '#77787b',
    },
    // additional colors
    input: {
      main: '#4dd970',
      contrastText: '#ffffff',
    },
    minor: {
      main: '#ededed',
      contrastText: '#4b6a72',
    },
  },
  typography: {
    fontWeightLight: 400,
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: '2.875rem',
      letterSpacing: '-1.5px',
    },
    h2: {
      fontWeight: 700,
      fontSize: '1.875rem',
      lineHeight: '2.3125rem',
      letterSpacing: '-0.5px',
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: '2rem',
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: '2rem',
      letterSpacing: '0.25px',
    },
    h5: {
      fontWeight: 700,
      fontSize: '0.875rem',
      lineHeight: '1.3125rem',
    },
    h6: {
      fontWeight: 700,
      fontSize: '0.7rem',
      lineHeight: '1rem',
      letterSpacing: '0.15px',
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: '1rem',
      lineHeight: '1.5rem',
      letterSpacing: '0.15px',
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      letterSpacing: '0.15px',
    },
    body1: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: '1.5rem',
      letterSpacing: '0.5px',
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      letterSpacing: '0.25px',
    },
    caption: {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: '1rem',
      letterSpacing: '0.4px',
    },
    overline: {
      fontWeight: 400,
      fontSize: '10px',
      lineHeight: '1rem',
      letterSpacing: '1.5px',
    },
  },
  background: '#FDFDFD',
  logo: null,
  customBorderRadius: {
    button: 25,
    paper: 8,
    chip: 100,
  },
  shadows: [
    'none',
    '0 0 0 1px #eae9e6',
    '0px 3px 1px -2px rgba(0,0,0,0.1),0px 2px 2px 0px rgba(0,0,0,0.05),0px 1px 5px 0px rgba(0,0,0,0.08)',
    '0px 3px 3px -2px rgba(0,0,0,0.1),0px 3px 4px 0px rgba(0,0,0,0.05),0px 1px 8px 0px rgba(0,0,0,0.08)',
    '0px 2px 4px -1px rgba(0,0,0,0.1),0px 4px 5px 0px rgba(0,0,0,0.05),0px 1px 10px 0px rgba(0,0,0,0.08)',
    '0px 3px 5px -1px rgba(0,0,0,0.1),0px 5px 8px 0px rgba(0,0,0,0.05),0px 1px 14px 0px rgba(0,0,0,0.08)',
    '0px 3px 5px -1px rgba(0,0,0,0.1),0px 6px 10px 0px rgba(0,0,0,0.05),0px 1px 18px 0px rgba(0,0,0,0.08)',
    '0px 4px 5px -2px rgba(0,0,0,0.1),0px 7px 10px 1px rgba(0,0,0,0.05),0px 2px 16px 1px rgba(0,0,0,0.08)',
    '0px 5px 5px -3px rgba(0,0,0,0.1),0px 8px 10px 1px rgba(0,0,0,0.05),0px 3px 14px 2px rgba(0,0,0,0.08)',
    '0px 5px 6px -3px rgba(0,0,0,0.1),0px 9px 12px 1px rgba(0,0,0,0.05),0px 3px 16px 2px rgba(0,0,0,0.08)',
    '0px 6px 6px -3px rgba(0,0,0,0.1),0px 10px 14px 1px rgba(0,0,0,0.05),0px 4px 18px 3px rgba(0,0,0,0.08)',
    '0px 6px 7px -4px rgba(0,0,0,0.1),0px 11px 15px 1px rgba(0,0,0,0.05),0px 4px 20px 3px rgba(0,0,0,0.08)',
    '0px 7px 8px -4px rgba(0,0,0,0.1),0px 12px 17px 2px rgba(0,0,0,0.05),0px 5px 22px 4px rgba(0,0,0,0.08)',
  ],
};

export default nemuruTheme;
